/* eslint-disable no-script-url */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/no-unknown-property */
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { ListGroup, Dropdown, Media, Form, Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { Button, Loader, Popover, Whisper } from 'rsuite'
import ChatList from './ChatList'
import { ConfigContext } from '../../../../contexts/ConfigContext'
import useAuth from '../../../../hooks/useAuth'
import { pageUrl } from '../../../../services/pageUrl'
import {
  NotificationContext,
  WebSocketContext,
} from '../../../../contexts/WebSocketContext'
import 'moment/locale/fr'
import { getDataService } from '../../../../services/back-end-service'
import { url } from '../../../../services/path-url'
// eslint-disable-next-line no-unused-vars
import { onError, onSuccess, isBo } from '../../../../utils/CommonMethods'
import UserProfile from '../../../../components/UserProfile'
import FicheDrawerComposant from '../../../../components/Cpi-fiche-drawer-component'
import FicheDrawerComposantUseForm from '../../../../components/Cpi-fiche-drawer-component-useform'
import { ENV_DEV } from '../../../../config/constant'
import UserAccessList from './access-client'

function NavRight({
  entity,
  scope,
  entity_scope_name,
  username,
  profile,
  logo,
  admin,
  client_access,
}) {
  const configContext = useContext(ConfigContext)
  const websocket = useContext(WebSocketContext)
  const { logout } = useAuth()
  const { rtlLayout } = configContext.state

  const {
    notifications: notifs,
    hasNewNotifications,
    updateHasNewNotifications,
    clearAll,
  } = useContext(NotificationContext)
  const [notifications, setNotifications] = useState([])

  const [listOpen, setListOpen] = useState(false)
  const [accessMetierOpen, setAccessMetierOpen] = useState(false)
  const [clearAllLoading, setClearAllLoading] = useState(false)
  const [popoverList, setPopoverList] = useState([])
  const { t, i18n } = useTranslation()

  const [notifChecked, setNotifChecked] = useState(false)
  const triggerRefs = useRef({})
  const [openNotif, setOpenNotif] = useState(false)
  const [openSettings, setOpenSettings] = useState(false)

  const handleLogout = async () => {
    try {
      logout()
    } catch (err) {
      return null
    }
  }

  useEffect(() => {
    const cookieValue = document.cookie
      .split('; ')
      .find((row) => row.startsWith('cpiNotifIsChecked='))
      ?.split('=')[1]
    setNotifChecked(cookieValue === 'true')
  }, [])

  useEffect(() => {
    moment.locale(i18n.language)
  }, [i18n.language])

  const handleNotifChecked = (e) => {
    const isChecked = e.target.checked
    setNotifChecked(isChecked)
    document.cookie = `cpiNotifIsChecked=${isChecked}; path=/`
  }

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
  }

  const handleClick = useCallback(
    (id) => {
      if (triggerRefs.current[id]) triggerRefs.current[id].close()
      if (websocket && websocket()) {
        websocket().send(
          `{"type":"notification_read","notification_id":"${id}"}`
        )
      }
    },
    [triggerRefs.current]
  )

  const handlePopoverEnter = useCallback(
    (id) => {
      if (popoverList.includes(id)) {
        setPopoverList((pop) => pop.filter((x) => x !== id))
        return
      }
      setPopoverList((pop) => [...pop, id])
    },
    [popoverList]
  )

  const onSuccessClearAll = useCallback(
    (res) => {
      onSuccess(res)
      clearAll()
    },
    [clearAll]
  )

  useEffect(() => {
    setNotifications(notifs.sort((a, b) => new Date(b.date) - new Date(a.date)))
  }, [notifs])

  const handleClearAll = useCallback(async () => {
    setClearAllLoading(true)
    await getDataService(
      url.notification.clear_all,
      onSuccessClearAll,
      onError
    ).finally(() => setClearAllLoading(false))
  }, [onSuccessClearAll])

  const filteredNotifications = notifications.filter(({ is_read }) =>
    notifChecked ? !is_read : true
  )

  function getRandomPaleColor() {
    // List of pale colors
    const paleColors = [
      '#FAD02E', // Pale Yellow
      '#F4A460', // Sandy Brown
      '#ADD8E6', // Light Blue
      '#98FB98', // Pale Green
      '#FFDAB9', // Peach Puff
      '#FFECB3', // Light Goldenrod
      '#B0E0E6', // Powder Blue
    ]
    const randomIndex = Math.floor(Math.random() * paleColors.length)
    return paleColors[randomIndex]
  }

  return (
    <>
      <div as="h5" style={{ paddingLeft: '0.5rem' }}>
        {' '}
        {entity_scope_name}
      </div>
      {logo && (
        <img
          src={`data:image/png;base64,${logo}`}
          alt="Logo"
          style={{ width: 'auto', height: '65px' }}
          className="navbar-nav ml-auto"
        />
      )}
      <ListGroup
        as="ul"
        bsPrefix=" "
        className="navbar-nav ml-auto"
        id="navbar-right"
      >
        {admin?.length > 0 ? (
          <ListGroup.Item as="li" bsPrefix=" ">
            <Dropdown
              alignRight={!rtlLayout}
              onToggle={() => {
                setOpenSettings((val) => !val)
              }}
            >
              <Dropdown.Toggle
                variant="link"
                to="#"
                id="dropdown-administration"
              >
                <i className="icon feather icon-settings" />
              </Dropdown.Toggle>

              <FicheDrawerComposant
                show={openSettings}
                style={{ color: 'black !important' }}
                className="custom-drawer"
                size="lg"
                isViewMode
                onClose={() => setOpenSettings(false)}
                title={t('Administration')}
                cardBody={
                  <Row>
                    {admin?.map((test, index) => (
                      <Col
                        key={`${index}-${test.menu_title}`}
                        md={3}
                        className={`cls-${test.id}`}
                      >
                        <div className="nav-item pcoded-hasmenu">
                          <hr />
                          <span
                            className="pcoded-micon"
                            style={{
                              paddingRight: '7px',
                              color: getRandomPaleColor(),
                            }}
                          >
                            <i className={test.icon} />
                          </span>
                          <span
                            className="pcoded-mtext"
                            style={{ color: '#D3497B' }}
                          >
                            {test.title}
                          </span>
                          <hr />
                        </div>
                        {test.children.map((submen, index) => (
                          <Form.Group
                            key={`${index}-${submen.title}`}
                            className="mb-1"
                          >
                            <Link
                              style={{ color: 'white', textDecoration: 'none' }}
                              to={submen.url}
                              onClick={() => setOpenSettings(false)}
                            >
                              {submen.title}
                            </Link>
                          </Form.Group>
                        ))}
                      </Col>
                    ))}
                  </Row>
                }
              />
            </Dropdown>
          </ListGroup.Item>
        ) : (
          <></>
        )}

        <ListGroup.Item as="li" bsPrefix=" ">
          <Dropdown
            alignRight={!rtlLayout}
            onToggle={(isShow) => {
              setOpenNotif((val) => !val)
              if (isShow && hasNewNotifications) {
                updateHasNewNotifications(false)
              }
            }}
          >
            <Dropdown.Toggle
              // as={Link}
              variant="link"
              to="#"
              id="dropdown-notification"
            >
              <i
                className={`feather icon-bell icon ${
                  hasNewNotifications > 0 ? 'active-badge' : ''
                }`}
              />
            </Dropdown.Toggle>
            <FicheDrawerComposantUseForm
              default
              open={openNotif}
              onClose={() => setOpenNotif(false)}
              size="xs"
              title={t('notification.title')}
              hideActions
              bodyClassName="notification-wrapper"
              cardBody={
                <>
                  <div className="switch">
                    <input
                      checked={notifChecked}
                      onChange={handleNotifChecked}
                      type="checkbox"
                      id="switch"
                    />
                    <Form.Label htmlFor="switch">
                      <span />
                      <span>{t('notification.show_not_seen')}</span>
                    </Form.Label>
                  </div>
                  {filteredNotifications.length > 0 ? (
                    <>
                      <div className="noti-top">
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault()
                            handleClearAll()
                          }}
                        >
                          {clearAllLoading ? (
                            <Loader size="xs" />
                          ) : (
                            t('notification.clear_all')
                          )}
                        </Link>
                      </div>
                      <PerfectScrollbar className="notification-scrollbar">
                        <ListGroup
                          as="ul"
                          bsPrefix=" "
                          variant="flush"
                          className="noti-body"
                        >
                          {filteredNotifications.map(
                            ({ message, is_read, notification_id, date }) => (
                              <ListGroup.Item
                                as="li"
                                key={notification_id}
                                bsPrefix=" "
                                className={`notification notif-item ${
                                  !is_read ? 'unread' : ''
                                }`}
                              >
                                <Media>
                                  <Media.Body>
                                    {!is_read && <span />}
                                    <p>
                                      <span className="notification-time text-muted">
                                        <i className="icon feather icon-clock m-r-10" />
                                        {moment(date).fromNow()}
                                      </span>
                                    </p>
                                    <p className="content">{message}</p>
                                    <Whisper
                                      trigger="click"
                                      placement="autoVerticalEnd"
                                      ref={(e) =>
                                        e
                                          ? (triggerRefs.current[
                                              notification_id
                                            ] = e)
                                          : undefined
                                      }
                                      controlId={`notif-${notification_id}`}
                                      speaker={
                                        <Popover className="p-1">
                                          <Button
                                            appearance="subtle"
                                            onClick={(e) => {
                                              e.preventDefault()
                                              handleClick(notification_id)
                                            }}
                                          >
                                            {t('notification.mark_as_read')}
                                          </Button>
                                        </Popover>
                                      }
                                      onEnter={() =>
                                        handlePopoverEnter(notification_id)
                                      }
                                      onExited={() =>
                                        handlePopoverEnter(notification_id)
                                      }
                                    >
                                      <div
                                        className={`notification-item-options-wrapper ${
                                          popoverList.includes(notification_id)
                                            ? 'active'
                                            : ''
                                        }`}
                                      >
                                        <div className="notification-item-options-body">
                                          <div
                                            className="notification-item-options"
                                            role="button"
                                            tabIndex={0}
                                            aria-label="Menu"
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="20"
                                              height="20"
                                              viewBox="0 0 16 16"
                                            >
                                              <path
                                                fill="currentColor"
                                                d="M9.5 13a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0z"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                    </Whisper>
                                  </Media.Body>
                                </Media>
                              </ListGroup.Item>
                            )
                          )}
                        </ListGroup>
                      </PerfectScrollbar>
                    </>
                  ) : (
                    <div className="notification-empty">
                      <span>{t('notification.empty')}</span>
                    </div>
                  )}
                  <div className="noti-footer" />
                </>
              }
            />
          </Dropdown>
        </ListGroup.Item>
        {process.env.NODE_ENV === ENV_DEV ? (
          <ListGroup.Item as="li" bsPrefix=" ">
            <Dropdown alignRight={!rtlLayout} className="drp-user">
              <Dropdown.Toggle
                // as={Link}
                variant="link"
                to="#"
                id="dropdown-language"
              >
                <i className="icon feather icon-globe" />
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight className="profile-notification">
                <ListGroup
                  as="ul"
                  bsPrefix=" "
                  variant="flush"
                  className="pro-body"
                >
                  <ListGroup.Item as="li" bsPrefix=" ">
                    <Link
                      to="#"
                      className="dropdown-item"
                      onClick={() => changeLanguage('en')}
                    >
                      English
                    </Link>
                  </ListGroup.Item>
                  <ListGroup.Item as="li" bsPrefix=" ">
                    <Link
                      to="#"
                      className="dropdown-item"
                      onClick={() => changeLanguage('fr')}
                    >
                      French
                    </Link>
                  </ListGroup.Item>
                  <ListGroup.Item as="li" bsPrefix=" ">
                    <Link
                      to="#"
                      className="dropdown-item"
                      onClick={() => changeLanguage('es')}
                    >
                      Spanish
                    </Link>
                  </ListGroup.Item>
                  <ListGroup.Item as="li" bsPrefix=" ">
                    <Link
                      to="#"
                      className="dropdown-item"
                      onClick={() => changeLanguage('de')}
                    >
                      Langue Test
                    </Link>
                  </ListGroup.Item>
                </ListGroup>
              </Dropdown.Menu>
            </Dropdown>
          </ListGroup.Item>
        ) : (
          <></>
        )}

        {client_access?.client_data_access == true ? (
          <ListGroup.Item as="li" bsPrefix=" ">
            <Dropdown>
              <Dropdown.Toggle
                // as={Link}
                variant="link"
                to="#"
                className="displayChatbox"
                onClick={() => setAccessMetierOpen(true)}
              >
                <i className="icon feather icon-list" />
              </Dropdown.Toggle>
            </Dropdown>
          </ListGroup.Item>
        ) : (
          <></>
        )}
        {!isBo() && (
          <ListGroup.Item as="li" bsPrefix=" ">
            <Dropdown>
              <Dropdown.Toggle
                // as={Link}
                variant="link"
                to="#"
                className="displayChatbox"
                onClick={() => setListOpen(true)}
              >
                <i className="icon feather icon-list" />
              </Dropdown.Toggle>
            </Dropdown>
          </ListGroup.Item>
        )}

        <ListGroup.Item as="li" bsPrefix=" " className="last-item">
          <Dropdown alignRight={!rtlLayout} className="drp-user">
            <Dropdown.Toggle
              // as={Link}
              variant="link"
              to="#"
              id="dropdown-profile"
            >
              <div className="pro-head">
                <span>{username}</span>
                <UserProfile profile={profile} isSignin />
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu
              alignRight
              className="profile-notification"
              style={{ marginTop: 8 }}
            >
              <Dropdown.Item
                as={Link}
                to={pageUrl.profile.edit}
                className="py-1"
              >
                <i
                  style={{ color: '#01a9ac' }}
                  className="feather icon-user  px-2"
                />
                {t('user.profile.dashboard_modal.account')}
              </Dropdown.Item>

              <Dropdown.Item as={Link} to="/change_log" className="py-1">
                <i
                  style={{ color: '#4AA3BA' }}
                  className="feather icon-monitor px-2"
                />
                {t('user.profile.dashboard_modal.change_log')}
              </Dropdown.Item>

              <Dropdown.Item
                onClick={(e) => {
                  e.preventDefault()
                  handleLogout()
                }}
                className="py-1"
              >
                <i
                  style={{ color: '#d3014c' }}
                  className="feather icon-log-out  px-2"
                />
                {t('user.profile.dashboard_modal.logout')}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </ListGroup.Item>
      </ListGroup>
      <ChatList
        listOpen={listOpen}
        closed={(e) => {
          e.preventDefault()
          e.stopPropagation()
          setListOpen(false)
        }}
        entity={entity}
        scope={scope}
      />

      <UserAccessList
        listOpen={accessMetierOpen}
        closed={(e) => {
          e.preventDefault()
          e.stopPropagation()
          setAccessMetierOpen(false)
        }}
        UserMetierAccess={client_access?.client}
        UserAdminAccess={client_access?.log_as_client}
        hideDrawer={() => setAccessMetierOpen(false)}
      />
    </>
  )
}

export default NavRight

